import { render, staticRenderFns } from "./Indices.vue?vue&type=template&id=ce3f4fae&scoped=true&"
import script from "./Indices.vue?vue&type=script&lang=js&"
export * from "./Indices.vue?vue&type=script&lang=js&"
import style0 from "./Indices.vue?vue&type=style&index=0&id=ce3f4fae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce3f4fae",
  null
  
)

export default component.exports